
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7YZnR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9bc6e262a5451a27$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aACZr = parcelRequire("aACZr");

var $gJPE6 = parcelRequire("gJPE6");

var $dVhJ8 = parcelRequire("dVhJ8");

var $iL5oi = parcelRequire("iL5oi");

var $l4KeD = parcelRequire("l4KeD");

var $jFdmN = parcelRequire("jFdmN");

var $dklJA = parcelRequire("dklJA");

var $iLJeT = parcelRequire("iLJeT");

var $4Q1tF = parcelRequire("4Q1tF");

var $dtKoB = parcelRequire("dtKoB");

var $iCMjC = parcelRequire("iCMjC");

var $5aE2v = parcelRequire("5aE2v");

var $hW7sX = parcelRequire("hW7sX");

var $aur9A = parcelRequire("aur9A");
function $9bc6e262a5451a27$export$2e2bcd8739ae039() {
    const { logout: logout, refresh: refresh, teamMemberships: teamMemberships, teams: teams } = (0, $iCMjC.useAuthentication)();
    const { confirm: confirm } = (0, $5aE2v.useModal)();
    const [deletedTeamIds, setDeletedTeamIds] = (0, $acw62.useState)([]);
    const visibleTeamMemberships = teamMemberships?.filter((tm)=>!deletedTeamIds.includes(tm.team.id)) ?? [];
    const possibleBillingOwnerIds = visibleTeamMemberships.filter((m)=>m.permissions.canManageBilling && !m.team.billingDelegatedToId).map((tm)=>tm.team.id);
    const [newTeamData, setNewTeamData] = (0, $acw62.useState)(null);
    const isLastTeam = visibleTeamMemberships.length === 1;
    (0, $aACZr.default)((0, $dtKoB.default)("Manage Teams"));
    const { call: leaveTeamCall } = (0, $hW7sX.useApi)("up.settings.teams.membership.delete");
    const { call: deleteTeamCall } = (0, $hW7sX.useApi)("up.settings.teams.delete");
    function onNewTeamClick(billingOwnerId) {
        setNewTeamData({
            billingOwnerId: billingOwnerId
        });
    }
    async function onNewTeamDone() {
        setNewTeamData(null);
        await refresh();
    }
    async function onDeleteTeamClick(teamId) {
        const confirmed = await confirm({
            cancelText: (0, $dtKoB.default)("Cancel"),
            confirmText: isLastTeam ? (0, $dtKoB.default)("Delete my account") : (0, $dtKoB.default)("Delete team"),
            content: isLastTeam ? (0, $dtKoB.default)("This is your last team! If you delete it, your user account will also be deleted with it. Are you sure?") : (0, $dtKoB.default)("Are you sure you want to delete this team?"),
            title: isLastTeam ? (0, $dtKoB.default)("Delete account?") : (0, $dtKoB.default)("Delete team?"),
            type: "warning"
        });
        if (!confirmed) return;
        await deleteTeamCall({
            teamId: teamId
        });
        if (isLastTeam) {
            await logout();
            return;
        }
        setDeletedTeamIds((teamIds)=>[
                ...teamIds,
                teamId
            ]);
        await refresh();
    }
    async function onLeaveTeamClick(teamId) {
        const confirmed = await confirm({
            cancelText: (0, $dtKoB.default)("Cancel"),
            confirmText: isLastTeam ? (0, $dtKoB.default)("Delete my account") : (0, $dtKoB.default)("Leave team"),
            content: isLastTeam ? (0, $dtKoB.default)("This is your last team! If you leave it, your user account will also be deleted with it. Are you sure you want to leave this team and delete your user account?") : (0, $dtKoB.default)("Are you sure you want to leave team?"),
            title: isLastTeam ? (0, $dtKoB.default)("Delete account?") : "Leave team?",
            type: "warning"
        });
        if (!confirmed) return;
        await leaveTeamCall({
            teamId: teamId
        });
        if (isLastTeam) {
            await logout();
            return;
        }
        await refresh();
    }
    if (!teamMemberships) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJPE6.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFdmN.default), {})
    });
    if (newTeamData) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJPE6.default), {
        narrow: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aur9A.default), {
            ...newTeamData,
            onDone: onNewTeamDone
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJPE6.default), {
        narrow: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dklJA.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dklJA.default).Header, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dklJA.default).Left, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dklJA.default).Title, {
                                children: (0, $dtKoB.default)("Manage Teams")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dklJA.default).Right, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iL5oi.default), {
                                onClick: ()=>{
                                    onNewTeamClick();
                                },
                                children: (0, $dtKoB.default)("New Team")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iLJeT.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).Header, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iLJeT.default).Row, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).Cell, {
                                        children: (0, $dtKoB.default)("Name")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).Cell, {
                                        invisible: true,
                                        shrink: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).Body, {
                            children: visibleTeamMemberships.filter((tm)=>!tm.team.isSubaccount || !teams.map((t)=>t.id).includes(tm.team.billingDelegatedToId)).map((teamMembership)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iLJeT.default).Row, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iLJeT.default).Cell, {
                                                    children: [
                                                        teamMembership.isOwner && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dVhJ8.default), {
                                                            children: (0, $dtKoB.default)("Owner")
                                                        }),
                                                        " ",
                                                        teamMembership.team.domain,
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).SubText, {
                                                            children: (0, $4Q1tF.PRODUCT_NAME)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).Cell, {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l4KeD.default), {
                                                        links: [
                                                            possibleBillingOwnerIds.includes(teamMembership.team.id) && {
                                                                name: (0, $dtKoB.default)("New subaccount"),
                                                                onClick: ()=>{
                                                                    onNewTeamClick(teamMembership.team.id);
                                                                }
                                                            },
                                                            teamMembership.isOwner ? teamMembership.team.deletable && {
                                                                color: "red",
                                                                name: isLastTeam ? (0, $dtKoB.default)("Delete my account") : (0, $dtKoB.default)("Delete team"),
                                                                onClick: async ()=>onDeleteTeamClick(teamMembership.team.id)
                                                            } : {
                                                                color: "red",
                                                                name: isLastTeam ? (0, $dtKoB.default)("Delete my account") : (0, $dtKoB.default)("Leave team"),
                                                                onClick: async ()=>onLeaveTeamClick(teamMembership.team.id)
                                                            }
                                                        ].filter(Boolean),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l4KeD.DropdownIcon), {})
                                                    })
                                                })
                                            ]
                                        }),
                                        visibleTeamMemberships.filter((tm)=>tm.team.billingDelegatedToId === teamMembership.team.id).map((subTeamMembership)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iLJeT.default).Row, {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iLJeT.default).Cell, {
                                                        subCell: true,
                                                        children: [
                                                            subTeamMembership.isOwner && teamMembership.isOwner && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dVhJ8.default), {
                                                                children: (0, $dtKoB.default)("Subaccount")
                                                            }),
                                                            " ",
                                                            subTeamMembership.team.domain,
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).SubText, {
                                                                children: (0, $4Q1tF.PRODUCT_NAME)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iLJeT.default).Cell, {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l4KeD.default), {
                                                            links: [
                                                                subTeamMembership.isOwner ? subTeamMembership.team.deletable && {
                                                                    color: "red",
                                                                    name: isLastTeam ? (0, $dtKoB.default)("Delete my account") : (0, $dtKoB.default)("Delete subaccount"),
                                                                    onClick: async ()=>onDeleteTeamClick(subTeamMembership.team.id)
                                                                } : {
                                                                    color: "red",
                                                                    name: isLastTeam ? (0, $dtKoB.default)("Delete my account") : (0, $dtKoB.default)("Leave subaccount"),
                                                                    onClick: async ()=>onLeaveTeamClick(subTeamMembership.team.id)
                                                                }
                                                            ].filter(Boolean),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l4KeD.DropdownIcon), {})
                                                        })
                                                    })
                                                ]
                                            }, subTeamMembership.id))
                                    ]
                                }, teamMembership.id))
                        })
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("aACZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b5b82c49fa2535e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $7b5b82c49fa2535e$var$DEFAULT_USE_TITLE_OPTIONS = {
    restoreOnUnmount: false
};
function $7b5b82c49fa2535e$var$useTitle(title, options) {
    if (options === void 0) options = $7b5b82c49fa2535e$var$DEFAULT_USE_TITLE_OPTIONS;
    var prevTitleRef = (0, $acw62.useRef)(document.title);
    if (document.title !== title) document.title = title;
    (0, $acw62.useEffect)(function() {
        if (options && options.restoreOnUnmount) return function() {
            document.title = prevTitleRef.current;
        };
        else return;
    }, []);
}
var $7b5b82c49fa2535e$export$2e2bcd8739ae039 = typeof document !== 'undefined' ? $7b5b82c49fa2535e$var$useTitle : function(_title) {};

});

parcelRegister("gJPE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $632bbca33caa5436$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $01O3F = parcelRequire("01O3F");

var $bsRud = parcelRequire("bsRud");

var $jFdmN = parcelRequire("jFdmN");
function $632bbca33caa5436$export$2e2bcd8739ae039({ children: children, narrow: narrow }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "px-4 py-8 sm:px-6 lg:px-8 text-black dark:text-white relative",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, $01O3F.classNames)("space-y-6", narrow && "max-w-4xl mx-auto"),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bsRud.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFdmN.default), {})
                }),
                children: children
            })
        })
    });
}
$632bbca33caa5436$export$2e2bcd8739ae039.Title = ({ children: children, right: right })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-10 mb-6 flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "text-3xl font-semibold flex-1",
                children: children
            }),
            right
        ]
    });
$632bbca33caa5436$export$2e2bcd8739ae039.Heading = ({ children: children, right: right })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-10 mb-6 flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-lg font-semibold flex-1",
                children: children
            }),
            right
        ]
    });

});

parcelRegister("dVhJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1320c702deed410$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $01O3F = parcelRequire("01O3F");
function $a1320c702deed410$export$2e2bcd8739ae039({ children: children, color: color, className: className, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $01O3F.classNames)("rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-semibold ring-1 ring-inset ring-black/20", color === "green" && "text-green-700 bg-green-50 ring-green-600/20", color === "red" && "text-red-700 bg-red-50 ring-red-600/20", color === "blue" && "text-blue-800 bg-blue-50 ring-blue-600/20", color === "yellow" && "text-yellow-800 bg-yellow-100 ring-yellow-600/40", color === "gray" && "text-gray-700 bg-gray-50 ring-gray-600/20", onClick && "cursor-pointer", className),
        onClick: onClick,
        children: children
    });
}

});

parcelRegister("iLJeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $08cebb1676e2a37c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $01O3F = parcelRequire("01O3F");

var $iL5oi = parcelRequire("iL5oi");

var $doin4 = parcelRequire("doin4");

var $1YjC8 = parcelRequire("1YjC8");
function $08cebb1676e2a37c$var$Table({ children: children, freezeColumns: freezeColumns, narrow: narrow }) {
    const tableRef = (0, $acw62.useRef)(null);
    const [colWidths, setColWidths] = (0, $acw62.useState)(null);
    const prevColCountRef = (0, $acw62.useRef)(0);
    // Measure column widths once there is at least one body row
    (0, $acw62.useEffect)(()=>{
        if (!freezeColumns || colWidths) return;
        const table = tableRef.current;
        if (!table) return;
        const tbody = table.querySelector("tbody");
        if (!tbody || tbody.querySelectorAll("tr").length === 0) return;
        const ths = table.querySelectorAll("thead th");
        if (ths.length === 0) return;
        const widths = Array.from(ths).map((th)=>Math.round(th.getBoundingClientRect().width));
        setColWidths(widths);
    }, [
        freezeColumns,
        colWidths,
        children
    ]);
    // Reset widths on window resize
    (0, $acw62.useEffect)(()=>{
        if (!freezeColumns) return;
        const handler = ()=>{
            setColWidths(null);
        };
        window.addEventListener("resize", handler);
        return ()=>{
            window.removeEventListener("resize", handler);
        };
    }, [
        freezeColumns
    ]);
    // Reset when # of columns changes
    (0, $acw62.useEffect)(()=>{
        if (!freezeColumns) return;
        const table = tableRef.current;
        if (!table) return;
        const currentCount = table.querySelectorAll("thead th").length;
        if (prevColCountRef.current > 0 && currentCount !== prevColCountRef.current) setColWidths(null);
        prevColCountRef.current = currentCount;
    }, [
        children,
        freezeColumns
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "overflow-x-auto",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: "min-w-full divide-y divide-slate-200 dark:divide-black/20",
            ref: tableRef,
            children: [
                colWidths && /*#__PURE__*/ (0, $ayMG0.jsx)("colgroup", {
                    children: colWidths.map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                            style: {
                                width: `${w}px`
                            }
                        }, i))
                }),
                (0, $01O3F.addProps)(children, [
                    $08cebb1676e2a37c$var$Table.Header,
                    $08cebb1676e2a37c$var$Table.Body,
                    $08cebb1676e2a37c$var$Table.Footer
                ], {
                    narrow: narrow
                })
            ]
        })
    });
}
var $08cebb1676e2a37c$export$2e2bcd8739ae039 = $08cebb1676e2a37c$var$Table;
$08cebb1676e2a37c$var$Table.Header = ({ children: children, narrow: narrow })=>/*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
        className: "bg-slate-100/80 dark:bg-slate-900/10",
        children: (0, $01O3F.addProps)(children, $08cebb1676e2a37c$var$Table.Row, {
            header: true,
            narrow: narrow
        })
    });
$08cebb1676e2a37c$var$Table.Footer = ({ children: children, narrow: narrow })=>/*#__PURE__*/ (0, $ayMG0.jsx)("tfoot", {
        className: "bg-slate-100/80 dark:bg-gray-700/20",
        children: (0, $01O3F.addProps)(children, $08cebb1676e2a37c$var$Table.Row, {
            narrow: narrow
        })
    });
$08cebb1676e2a37c$var$Table.Body = ({ children: children, narrow: narrow })=>/*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
        className: "divide-y divide-slate-200 bg-white dark:divide-black/20 dark:bg-gray-800",
        children: (0, $01O3F.addProps)(children, $08cebb1676e2a37c$var$Table.Row, {
            narrow: narrow
        })
    });
$08cebb1676e2a37c$var$Table.Row = ({ active: active, children: children, header: header, narrow: narrow, onClick: onClick, opaque: opaque, verticalAlign: verticalAlign })=>/*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
        className: "group/table-row",
        children: (0, $01O3F.addProps)(children, $08cebb1676e2a37c$var$Table.Cell, {
            active: active,
            header: header,
            narrow: narrow,
            onClick: onClick,
            opaque: opaque,
            verticalAlign: verticalAlign
        })
    });
$08cebb1676e2a37c$var$Table.Cell = ({ active: active, align: align, children: children, className: className, header: header, invisible: invisible, narrow: narrow, onClick: onClick, opaque: opaque, shrink: shrink, subCell: subCell, verticalAlign: verticalAlign, ...props })=>{
    header ??= false;
    invisible ??= false;
    header ??= false;
    align ??= "left";
    verticalAlign ??= "top";
    shrink ??= false;
    opaque ??= false;
    subCell ??= false;
    const classes = [
        align === "left" && "text-left",
        align === "right" && "text-right",
        align === "center" && "text-center",
        verticalAlign === "top" && "align-top",
        verticalAlign === "middle" && "align-middle",
        verticalAlign === "bottom" && "align-bottom",
        shrink && "w-1 whitespace-nowrap",
        active && "bg-gray-100 dark:bg-gray-700",
        narrow ? "px-2 py-2.5" : "px-3 py-3.5",
        onClick && "cursor-pointer group-hover/table-row:bg-gray-100 dark:group-hover/table-row:bg-gray-700",
        opaque && "opacity-50",
        subCell && "shadow-[inset_3px_0_0_0_#8D5AF5]",
        className
    ];
    children = (0, $01O3F.addProps)(children, [
        (0, $iL5oi.default),
        (0, $doin4.default),
        (0, $1YjC8.default)
    ], {
        size: narrow ? "xs" : "sm"
    });
    if (invisible) children = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "sr-only",
        children: children
    });
    if (header) return /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
        className: (0, $01O3F.classNames)("text-sm font-semibold text-gray-900 dark:text-white", ...classes),
        onClick: onClick,
        scope: "col",
        ...props,
        children: [
            children,
            " "
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
        className: (0, $01O3F.classNames)("text-gray-500 dark:text-gray-100", ...classes),
        onClick: onClick,
        ...props,
        children: children
    });
};
$08cebb1676e2a37c$var$Table.StrongText = ({ children: children, className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $01O3F.classNames)("mt-1 text-sm font-semibold leading-5 text-gray-900 dark:text-white", className),
        children: children
    });
$08cebb1676e2a37c$var$Table.SubText = ({ children: children, className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $01O3F.classNames)("block text-xs leading-5 text-gray-500 dark:text-gray-400", className),
        children: children
    });
$08cebb1676e2a37c$var$Table.SubCellTitle = ({ children: children, className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: (0, $01O3F.classNames)("block mt-4 mb-3 text-sm font-semibold leading-5 text-gray-900 dark:text-white", className),
        children: children
    });
$08cebb1676e2a37c$var$Table.SubCellWell = ({ children: children, className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $01O3F.classNames)("p-2 bg-slate-100 dark:bg-black/10 rounded", className),
        children: children
    });
$08cebb1676e2a37c$var$Table.Empty = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "inline-block h-0 w-8 border-b align-middle dark:border-gray-700"
    });
$08cebb1676e2a37c$var$Table.MultilineContent = ({ children: children })=>{
    if (!children || children.filter(Boolean).length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)($08cebb1676e2a37c$var$Table.Empty, {});
    return children.filter(Boolean).map((child, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
            children: child
        }, index);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($08cebb1676e2a37c$var$Table.SubText, {
            children: child
        }, index);
    });
};
$08cebb1676e2a37c$var$Table.Definition = ({ children: children, title: title })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "py-2 sm:grid sm:grid-cols-3 sm:gap-4",
        "data-role": "definition",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                className: "text-sm font-semibold text-gray-500 dark:text-gray-400",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                className: "underlined-links text-sm text-gray-700 sm:col-span-2 sm:mt-0 dark:text-gray-300",
                children: children
            })
        ]
    });
};

});
parcelRegister("1YjC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e3fd0c7995f08b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $iXFxr = parcelRequire("iXFxr");

var $01O3F = parcelRequire("01O3F");

var $iL5oi = parcelRequire("iL5oi");

var $NmU8R = parcelRequire("NmU8R");

var $l4KeD = parcelRequire("l4KeD");
function $f9e3fd0c7995f08b$export$2e2bcd8739ae039({ children: children, className: className, links: links, loading: loading, onClick: onClick, size: size }) {
    if (onClick) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $NmU8R.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iL5oi.default), {
                className: className,
                loading: loading,
                onClick: onClick,
                size: size,
                variant: "action",
                children: children
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l4KeD.default), {
                buttonAs: (0, $iL5oi.default),
                buttonProps: {
                    className: (0, $01O3F.classNames)(className, "px-1.5"),
                    loading: loading,
                    size: size,
                    variant: "action"
                },
                links: links,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iXFxr.default), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l4KeD.default), {
        links: links,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iL5oi.default), {
            className: className,
            loading: loading,
            size: size,
            variant: "action",
            children: [
                children,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iXFxr.default), {})
            ]
        })
    });
}

});
parcelRegister("iXFxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcddf554cab09b71$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $dcddf554cab09b71$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $dcddf554cab09b71$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($dcddf554cab09b71$var$ChevronDownIcon);
var $dcddf554cab09b71$export$2e2bcd8739ae039 = $dcddf554cab09b71$var$ForwardRef;

});

parcelRegister("NmU8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $5866bb767b046b66$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $01O3F = parcelRequire("01O3F");

var $iL5oi = parcelRequire("iL5oi");

var $doin4 = parcelRequire("doin4");

var $l4KeD = parcelRequire("l4KeD");

var $1YjC8 = parcelRequire("1YjC8");
function $5866bb767b046b66$export$2e2bcd8739ae039({ children: children, className: className }) {
    children = (0, $01O3F.addProps)(children, [
        (0, $iL5oi.default),
        (0, $doin4.default)
    ], {
        variant: "action"
    });
    children = (0, $01O3F.addClassNames)(children, "span", (0, $iL5oi.buttonClassName)({
        className: "pointer-events-none",
        size: "md",
        variant: "action"
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $01O3F.classNames)("inline-flex items-stretch", className),
        children: (0, $01O3F.addClassNames)(children, [
            (0, $iL5oi.default),
            (0, $1YjC8.default),
            (0, $doin4.default),
            (0, $l4KeD.default),
            "span"
        ], (index, count)=>{
            return [
                "-ml-[1px] focus:z-10",
                index === 0 && count !== 1 && "rounded-r-none",
                index !== 0 && index !== count - 1 && "rounded-none",
                index === count - 1 && count !== 1 && "rounded-l-none"
            ].filter(Boolean).join(" ");
        })
    });
}

});



parcelRegister("aur9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3f9058b2cfb7c0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $22i8b = parcelRequire("22i8b");

var $47MOw = parcelRequire("47MOw");

var $kG3Fh = parcelRequire("kG3Fh");

var $cSimh = parcelRequire("cSimh");

var $iL5oi = parcelRequire("iL5oi");

var $dklJA = parcelRequire("dklJA");

var $4Q1tF = parcelRequire("4Q1tF");

var $dtKoB = parcelRequire("dtKoB");

var $iCMjC = parcelRequire("iCMjC");

var $5aE2v = parcelRequire("5aE2v");

var $76TUS = parcelRequire("76TUS");

var $hW7sX = parcelRequire("hW7sX");

var $7xuAh = parcelRequire("7xuAh");
function $1c3f9058b2cfb7c0$export$2e2bcd8739ae039({ billingOwnerId: billingOwnerId, onDone: onDone }) {
    const { teams: teams, user: user } = (0, $iCMjC.useAuthentication)();
    const { confirm: confirm } = (0, $5aE2v.useModal)();
    const redirect = (0, $7xuAh.default)();
    const { call: createTeam, isLoading: isLoading } = (0, $hW7sX.useApi)("up.teams.create");
    const [error, setError] = (0, $acw62.useState)();
    const { formState: { isDirty: isDirty }, handleSubmit: handleSubmit, register: register, reset: reset, setValue: setValue } = (0, $22i8b.useForm)({
        defaultValues: {
            subIdentifier: ""
        }
    });
    const { markSaved: markSaved } = (0, $76TUS.useTrackUnsavedChanges)(isDirty);
    async function onSubmit(teamData) {
        const response = await createTeam({
            team: {
                billingOwnerId: billingOwnerId,
                subIdentifier: teamData.subIdentifier
            }
        });
        setError(undefined);
        if (response.success) {
            await onDone();
            reset();
            if (!billingOwnerId) {
                markSaved();
                redirect([
                    "hs.documentSharing.present",
                    {
                        teamDomain: response.team.domain
                    }
                ]);
            }
            return;
        }
        switch(response.error){
            case "domain_already_in_use":
                setError((0, $dtKoB.default)("This domain is already being used"));
                return;
            case "invalid_billing_owner":
                confirm({
                    content: (0, $dtKoB.default)("This parent team cannot have subaccounts."),
                    title: (0, $dtKoB.default)("Invalid parent team"),
                    type: "warning"
                });
                return;
            case "saml_user":
                confirm({
                    content: (0, $dtKoB.default)("Please ask your team administrator to create the new team and invite you to it."),
                    title: (0, $dtKoB.default)("You cannot create new teams"),
                    type: "warning"
                });
                return;
            default:
                response.error;
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dklJA.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dklJA.default).Header, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dklJA.default).Left, {
                        children: billingOwnerId ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dklJA.default).Title, {
                            children: [
                                "Create new ",
                                teams.find((t)=>t.id === billingOwnerId).domain,
                                " subaccount"
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dklJA.default).Title, {
                            children: [
                                "Create new ",
                                (0, $4Q1tF.PRODUCT_NAME),
                                " team"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dklJA.default).Right, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iL5oi.default), {
                            onClick: onDone,
                            variant: "action",
                            children: "Cancel"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dklJA.default).Content, {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $47MOw.default), {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kG3Fh.default), {
                            error: error,
                            label: "New team name",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cSimh.default), {
                                ...register("subIdentifier", {
                                    onChange: (e)=>{
                                        setError(undefined);
                                        const sanitized = e.target.value.replace(/[^a-z0-9-]/g, "");
                                        if (e.target.value !== sanitized) setValue("subIdentifier", sanitized);
                                    }
                                }),
                                autoFocus: true,
                                prefix: user.freeEmailDomain ? `${user.username}-` : undefined,
                                required: true,
                                suffix: user.freeEmailDomain ? undefined : `.${user.emailDomain}`,
                                type: "text"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iL5oi.default), {
                            disabled: !isDirty,
                            loading: isLoading,
                            type: "submit",
                            children: "Create team"
                        })
                    ]
                })
            })
        ]
    });
}

});



//# sourceMappingURL=ManageTeams.063f7462.js.map
